import { render, staticRenderFns } from "./BodegaMenuDevolucion.vue?vue&type=template&id=8136332a&scoped=true"
import script from "./BodegaMenuDevolucion.vue?vue&type=script&lang=js"
export * from "./BodegaMenuDevolucion.vue?vue&type=script&lang=js"
import style0 from "./BodegaMenuDevolucion.vue?vue&type=style&index=0&id=8136332a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8136332a",
  null
  
)

export default component.exports